import { useState, useEffect } from "react";

function Chatbox() {
  // console.log("In CHATBOX");

  return (
    <div className="status-wrapper" id="chatbox-wrapper">
      <div className="status-title">
        <p>⊹ chatbox</p>
      </div>
     <iframe src="https://www3.cbox.ws/box/?boxid=3561008&boxtag=JtlvoP" width="100%" height="100%" allowtransparency="yes" allow="autoplay" frameBorder="0" marginHeight="0" marginWidth="0" scrolling="auto"></iframe>	
    </div>
  );
}

export default Chatbox;